import api from '../resources/apiProvider'
import storeAuth from '../stores/auth'
import _ from 'lodash'

const NAME_FOR_FILTER = {
    MAIN: 'data_filters',
    MODEL_CUSTOM: "custom_fm_filters",
    ALL_REPORTS: "reports"
}
export default {
    async updateUser(user = false) {
        if (!user) {
            user = _.cloneDeep(storeAuth.getters.getUser)
        }
        let userId = user.id
        delete user.id

        //console.log("user", user)
        let res = api.getFromUri(api.getResourceUri().user.base)
        return await res.update({id: userId}, user)
    },
    async setAdminSiteAuthorized(loginUser, sitesAuthorized) {
        let res = api.getFromUri(api.getResourceUri().user.getUserByLogin)
        let result = res.get({login: loginUser})

        result.then(res => {
            let user = res.data
            user.sitesAuthorize = sitesAuthorized
            return this.updateUser(user)
        })
    },
    async getUserByGuid(guid) {
        let res = api.getFromUri(api.getResourceUri().user.getUserByGuid)
        let result = await res.get({guid})
        return _.isEmpty(result.data) ? false : result.data
    },
    async saveUser(user) {
        let selectUserWdr = _.cloneDeep(user)
        let resUser = api.getFromUri(api.getResourceUri().user.base)
        let objToSave = {
            guid: selectUserWdr.guid,
            firstname: selectUserWdr.firstname,
            lastname: selectUserWdr.lastname
        }
        let req = await resUser.save(objToSave)
        return req.data
    },
    getTodReportingInformations(user, field = null) {
        if (_.isUndefined(user.todReporting)) {
            return false
        }
        if (_.isNull(field)) {
            return user.todReporting
        } else {
            if (!_.isUndefined(user.todReporting[field])) {
                return user.todReporting[field]
            } else {
                return false
            }
        }

    }
}